// src/components/copilot/ChatInput.jsx
import { Send as SendIcon } from "@mui/icons-material";
import { Box, Button, Paper, TextField } from "@mui/material";
import { grey } from "@mui/material/colors";
import { memo, useCallback } from "react";

const ChatInput = memo(({ input, setInput, isLoading, onSendMessage }) => {
  const handleKeyPress = useCallback(
    (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        onSendMessage();
      }
    },
    [onSendMessage],
  );

  const handleChange = useCallback(
    (e) => {
      setInput(e.target.value);
    },
    [setInput],
  );

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1,
        pl: 0.5,
        borderRadius: 0,
        borderTop: `1px solid ${grey[200]}`,
      }}
    >
      <Box sx={{ display: "flex", gap: 0, alignItems: "center" }}>
        <TextField
          fullWidth
          multiline
          maxRows={4}
          size="small"
          sx={{
            ".MuiInputBase-root": {
              p: 2,
            },
            fieldset: {
              border: "none",
            },
          }}
          placeholder="Ask me anything..."
          value={input}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          disabled={isLoading}
        />
        <Button
          variant="contained"
          onClick={() => onSendMessage()}
          disabled={isLoading || !input.trim()}
          sx={{ minWidth: 48, height: 48 }}
        >
          <SendIcon />
        </Button>
      </Box>
    </Paper>
  );
});

ChatInput.displayName = "ChatInput";

export default ChatInput;
